import React from 'react'

import { StyledLink, Bold } from './styles.js'

class Logo extends React.Component {

    render() {
        return (
            <StyledLink to='/' theme={!this.props.menuActive ? this.props.theme : 'dark'} >
                20Med<Bold> Therapeutics</Bold>
            </StyledLink>
        )
    }

}

export default Logo